/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_Field_LabelInputs */

const en_workflow_time_field_label = /** @type {(inputs: Workflow_Time_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event time`)
};

const ja_workflow_time_field_label = /** @type {(inputs: Workflow_Time_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント時刻`)
};

const fr_workflow_time_field_label = /** @type {(inputs: Workflow_Time_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de l’événement`)
};

const de_workflow_time_field_label = /** @type {(inputs: Workflow_Time_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereigniszeit`)
};

/**
* | output |
* | --- |
* | "Event time" |
*
* @param {Workflow_Time_Field_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_field_label = /** @type {((inputs?: Workflow_Time_Field_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_Field_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_field_label(inputs)
	if (locale === "ja") return ja_workflow_time_field_label(inputs)
	if (locale === "fr") return fr_workflow_time_field_label(inputs)
	return de_workflow_time_field_label(inputs)
});